import { CheckCircle, Loader2 } from 'lucide-react'
import { Card } from '../components/ui/card'
import { useAuth } from '../stores/authStore'

export const EmailConfirmedPage = () => {
  const { user: _user, loading } = useAuth()

  // Show loading state while checking auth
  if (loading) {
    return (
      <div className="bg-background flex h-screen items-center justify-center p-8">
        <Loader2 className="text-primary h-8 w-8 animate-spin" />
      </div>
    )
  }

  return (
    <div className="bg-background flex h-screen items-center justify-center p-8">
      <Card className="w-full max-w-md space-y-6 p-8 text-center">
        <div className="flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-500/10">
            <CheckCircle className="h-8 w-8 text-green-500" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-bold">Email Confirmed!</h1>
          <p className="text-muted-foreground">Your email has been successfully verified</p>
        </div>

        <div className="space-y-4">
          <p className="text-muted-foreground text-sm">
            You may now close this window and return to the previous tab to continue setting up
          </p>
        </div>
      </Card>
    </div>
  )
}
